const m = {
  small: "small",
  medium: "medium",
  large: "large"
}, i = (l) => {
  let e = "24px";
  return l === m.medium ? e = "30px" : l === m.large && (e = "34px"), e;
};
export {
  i as getSize,
  m as sizes
};
